import 'antd/dist/antd.min.css'
import '../assets/scss/base.scss'
import React from 'react'
import { message } from 'antd'
import { AppRouter } from './AppRouter'
import { ErrorBoundary } from './shared/ErrorBoundary'
import { Meta } from './shared/Meta'
import { rpc } from '../lib/Rpc'

export const App = () => {
  React.useEffect(() => rpc.onError(m => message.error(`RPC: ${m}`)), [])

  return (
    <ErrorBoundary>
      <Meta />
      <AppRouter />
    </ErrorBoundary>
  )
}
